/**
 * @generated SignedSource<<7333916004bfa18b6d9ab26213626d60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateRow_reportTemplate$data = {
  readonly id: string;
  readonly name: string | null;
  readonly config: any | null;
  readonly deletedAt: any | null;
  readonly organization: {
    readonly defaultReportSections: any | null;
  } | null;
  readonly " $fragmentType": "TemplateRow_reportTemplate";
};
export type TemplateRow_reportTemplate$key = {
  readonly " $data"?: TemplateRow_reportTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateRow_reportTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplateRow_reportTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "config",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultReportSections",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ReportTemplate",
  "abstractKey": null
};

(node as any).hash = "c6d5e116c32fadaf1c3325b5d7b757d4";

export default node;
